//Keydown numbers
export enum KeyCodes {
    TAB = 9,
    RETURN = 13,
    ESC = 27,
    SPACE = 32,
    PAGEUP = 33,
    PAGEDOWN = 34,
    END = 35,
    HOME = 36,
    LEFT = 37,
    UP = 38,
    RIGHT = 39,
    DOWN = 40
};

//Outline focus styling state
const outlineStylingActive = true;

export const isOutlineStylingActive = () => outlineStylingActive;

export const mimicLoading = async (timeout = 2000) => {
    try {
        return await new Promise<void>(resolve => {
            setTimeout(() => {
                resolve();
            }, timeout);
        });
    } catch (e) { }
};

export const validateEmail = value => {
    return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
        value
    );
};

export const isIE = () => navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;

export const querySelector = <T extends HTMLElement>(selector: string, parent: HTMLElement = null): T => {
    const elm = parent ? parent : document;
    return elm?.querySelector(selector);
}

export const querySelectorAll = <T extends HTMLElement>(selector: string, parent: HTMLElement = null): NodeListOf<T> => {
    const elm = parent ? parent : document;
    return elm?.querySelectorAll(selector);
}

export class EmptyNodeList<T extends Node> implements NodeListOf<T> {
    [index: number]: T;
    length: number;
    item(index: number): T {
        //do nothing
        return null;
    }

    forEach(callbackfn: (value: T, key: number, parent: NodeListOf<T>) => void, thisArg?: any): void {
        //do nothing
    }
}

export const focusableElements =
    'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"])';